module.exports = __webpack_public_path__ + "img/construwood-m.cf50bf90.jpg";